import { useEffect } from "react";

export const SITE = "https://phoneplay.net";
export const DEFAULT_IMAGE = `${SITE}/og-image.jpg`;
const SUFFIX = " | PhonePlay";

function upsert(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(selector.startsWith("link") ? "link" : "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

// Per-page SEO: title, description, canonical, Open Graph, Twitter card, optional JSON-LD, robots.
export function useSeo({ title, description, path = "/", image = DEFAULT_IMAGE, type = "website", noindex = false, jsonLd = null }) {
  useEffect(() => {
    const fullTitle = title.endsWith("PhonePlay") ? title : title + SUFFIX;
    const url = SITE + path;
    document.title = fullTitle;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('meta[name="robots"]', { name: "robots", content: noindex ? "noindex, nofollow" : "index, follow" });
    upsert('link[rel="canonical"]', { rel: "canonical", href: url });
    upsert('meta[property="og:type"]', { property: "og:type", content: type });
    upsert('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:image"]', { property: "og:image", content: image });
    upsert('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsert('meta[name="twitter:image"]', { name: "twitter:image", content: image });

    let script = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "page-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, path, image, type, noindex, jsonLd]);
}
